import React from "react";
import store from "../store";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import ReactPlayer from "react-player";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import hideOnScroll from '../components/hideonscroll'
import MenuIcon from '@material-ui/icons/Menu';

import { NotificationManager } from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Link } from "react-router-dom";

import TopBar from '../components/TopBar';
import Paper from '@material-ui/core/Paper';

import { Redirect } from 'react-router-dom';
import ButtonBase from '@material-ui/core/ButtonBase';
import PowerIcon from '@material-ui/icons/PowerSettingsNew';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { FIREBASE } from "../config/firebase";
import Divider from '@material-ui/core/Divider';
import * as STATIC from '../config/static';
import _ from 'lodash';
import moment from "moment"

if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
  var re = /^([0-9]{6,20})$/;
  return re.test(phone);
};

const firestore = firebase.firestore();
//let IS_NAMING = window.location.hostname.toLowerCase()=='www1.namethegiraffe.com'?true:false;
//IS_NAMING = true;


var _this;

class HomePage extends React.Component {
  state = {
    viewDidLoad: false,
  };
  constructor() {
    super();
    _this = this;
    this.state={}

  }
  updateDimensions() {
    //console.log(window.innerWidth);
    // _this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
  }
  componentDidMount() {

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    //let encrypted = STATIC.encryptStringWithRsaPublicKey("JK1234");
    //console.log(encrypted);


    // this.setState({
    //   innerWidth: window.innerWidth,
    //   innerHeight: window.innerHeight
    // });
    //window.addEventListener("resize", this.updateDimensions);
    this.loadBingo();
  }
  async loadBingo(){
    let sDoc = await firebase.firestore().collection('Marathon').doc("#Setting").get();
    //console.log(sDoc.exists)
    if(sDoc.exists)
    {
      let setting = sDoc.data();
      setting.id = sDoc.id;
      if(moment(setting.endTime).isBefore(moment())||moment(setting.startTime).isAfter(moment()))
      {

        return;
      }
      _this.setState({setting});

    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    _this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }
  handleChange = name => event => {
    //event.preventDefault();
    _this.setState({ [name]: event.target.value });
  };



  getName(fullname)
  {
    return _.last(fullname.split(' '));
  }


  render() {
    const { classes,t } = this.props;
    const { loading, wWidth, wHeight,setting } = this.state;
    let width = 980;
    if (wWidth < 980) {
      width = wWidth;
    }
    let sRate = 640 / 1005;
    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let ACCOUNT = store.getState().ACCOUNT;
    let SOUND = store.getState().SOUND;

    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
let PERS = STATIC.PERS(ACCOUNT);

    let bWidth = STATIC.calSize(512, STATIC.DWIDTH, width);
    //console.log(ACCOUNT);
    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle} >
          <Link to={'/'} style={{ position: "fixed", width: "100%", bottom: 5, left: 5 }}>
            <img src="assets/web/logo_trans.png" style={{ width: STATIC.calSize(189, STATIC.DWIDTH, width), height: "auto" }} />
          </Link>
          <TopBar width={width} />


            <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
              <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px'), flexGrow: 1, position: 'relative' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />

                <div style={{ marginBottom: STATIC.calSize(30, STATIC.DWIDTH, width) }}>
                  <div style={{ textAlign: "center", color: '#053f22', margin: 0, fontSize: fTitle, fontFamily: 'UTMP' }}>{t('home.welcome',{name:this.getName(ACCOUNT.type==0?ACCOUNT.ten:ACCOUNT.hoten)})}</div>
                  <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />

                </div>


                <div style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),height:STATIC.calSize(828, STATIC.DWIDTH, width)}}>
                  <Grid container direction="column" alignItems="center" justify="center" >

                    {PERS.lesson?<Grid item xs style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width),opacity:0.5, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <Link to={'/#'}><ButtonBase focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth,height:bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                        <img src={"assets/web/icon_lesson_notext.png"} style={{ width: bWidth*0.5 }} />
                        <div style={{position:'absolute',top:bWidth*0.5/2-STATIC.calSize(31, STATIC.DWIDTH, width),left:STATIC.calSize(22, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontWeight:'bold',fontSize:width * 0.049,color:'white'}}>{t('common.lessons')}</div>
                        <div style={{position:'absolute',top:bWidth*0.5/2+STATIC.calSize(12, STATIC.DWIDTH, width),left:STATIC.calSize(22, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontSize:width * 0.021,color:'white'}}>BUILD FOUNDER LAND</div>
                      </ButtonBase>
                      </Link>
                    </Grid>:false}


                    {PERS.practice?<Grid item xs style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width), marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <Link to={'/practice'}><ButtonBase focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth,height:bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                        <img src={"assets/web/icon_practice_notext.png"} style={{ width: bWidth*0.5 }} />
                          <div style={{position:'absolute',top:bWidth*0.5/2-STATIC.calSize(46, STATIC.DWIDTH, width),left:STATIC.calSize(6, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontWeight:'bold',fontSize:width * 0.0475,color:'#043f22'}}>{t('common.practice')}</div>
                          <div style={{position:'absolute',top:bWidth*0.5/2-STATIC.calSize(5, STATIC.DWIDTH, width),left:STATIC.calSize(6, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontSize:width * 0.021,color:'#043f22'}}>MAKES DIFFERENT</div>
                      </ButtonBase>
                      </Link>
                    </Grid>:false}
                    {PERS.challenge&&!this.state.setting?<Grid item xs style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width),opacity:0.5, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <Link to={'/#'}><ButtonBase focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth,height:bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                        <img src={"assets/web/icon_challenge_notext.png"} style={{ width: bWidth*0.5 }} />
                          <div style={{position:'absolute',top:bWidth*0.5/2-STATIC.calSize(42, STATIC.DWIDTH, width),left:STATIC.calSize(6, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontWeight:'bold',fontSize:width * 0.0435,color:'#fff100'}}>{t('common.challenges')}</div>
                          <div style={{position:'absolute',top:bWidth*0.5/2-STATIC.calSize(2, STATIC.DWIDTH, width),left:STATIC.calSize(6, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontSize:width * 0.015,color:'#fff100'}}>CHALLENGE WITH OTHER FRIENDS</div>
                      </ButtonBase>
                      </Link>
                    </Grid>:this.state.setting&&ACCOUNT.type==0?<Grid item xs style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width),opacity:1, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <Link to={'/marathon'}><ButtonBase focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth,height:bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                        <img src={setting.button_img&&setting.button_img.length>0?setting.button_img:"assets/web/icon_challenge_notext.png"} style={{ width: bWidth*0.5 }} />
                        {/* <div style={{position:'absolute',top:0,bottom:0,left:0,right:0,display:'flex',alignItems:'center',justifyContent:'center'}}><img src={"assets/web/bb_logo.png"} style={{ width: bWidth*0.4 }} /></div> */}


                      </ButtonBase>
                      </Link>
                    </Grid>:false}
                    {PERS.class?<Grid item xs style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width), marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <Link to={'/classes'}><ButtonBase focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth,height:bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                        <img src={"assets/web/icon_lesson_notext.png"} style={{ width: bWidth*0.5 }} />
                        <div style={{position:'absolute',top:bWidth*0.5/2-STATIC.calSize(31, STATIC.DWIDTH, width),left:STATIC.calSize(22, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontWeight:'bold',fontSize:width * 0.049,color:'white'}}>{t('common.classes')}</div>
                        <div style={{position:'absolute',top:bWidth*0.5/2+STATIC.calSize(12, STATIC.DWIDTH, width),left:STATIC.calSize(22, STATIC.DWIDTH, width),right:0,textAlign:'center',textTransform:'uppercase',fontSize:width * 0.021,color:'white'}}>CLASS MANAGER</div>
                      </ButtonBase>
                      </Link>
                    </Grid>:false
                  }

                  </Grid>
                </div>

              </div>
            </div>

        </div>





      </div>
    );
  }
}

HomePage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(HomePage));
